import React, { ChangeEvent, FunctionComponent, useEffect, useState } from 'react'
import { Table, Typography, Col, Row, notification, Input, Space, Button } from 'antd'
import { FilterValue, SorterResult, TablePaginationConfig } from 'antd/lib/table/interface'

import { columns } from './columns'

import { DEFAULT_PAGE_SIZE } from '../../../../constants'
import { getIncompleteProfilesList } from '../../../../context/admin/utils'
import { IncompleteProfile } from '../../../../context/types'
import { useAuthContext } from '../../../../context/auth'
import { DownloadOutlined } from '@ant-design/icons'

const { Search } = Input
const { Title } = Typography

interface AdminIncompleteProfilesProps {
	state?: number
}

const IncompleteProfiles: FunctionComponent<AdminIncompleteProfilesProps> = (props) => {
	const { state } = props
	const { auth } = useAuthContext()

	const [loading, setLoading] = useState(false)

	const [filter, setFilter] = useState('')
	const [page, setPage] = useState(1)
	const [column, setColumn] = useState('email')
	const [order, setOrder] = useState<Order>('ascend')

	const [total, setTotal] = useState(10)
	const [profiles, setProfiles] = useState<IncompleteProfile[]>([])

	useEffect(() => {
		setLoading(true)
		getIncompleteProfilesList((page - 1) * DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE, column, order, filter)
			.then((r) => {
				setProfiles(r.list)
				setTotal(r.total)
			})
			.catch(handleError)
			.finally(() => setLoading(false))
	}, [page, order, column, state, filter])

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Server error' })
	}
	const handleSetFilter = (e: ChangeEvent<HTMLInputElement>) => setFilter(e.target.value)

	const onChange: OnChange = (pagination, _, sorter) => {
		const customSorter = sorter as SorterResult<IncompleteProfile>

		setOrder(customSorter.order as Order)
		setColumn(customSorter.columnKey as string)
		setPage(pagination.current)
	}

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			<Row>
				<Col md={14} xs={24}>
					<Title level={3}>Incomplete Profiles</Title>
				</Col>
				<Col md={3} xs={8}>
					<Button
						type="primary"
						shape="round"
						icon={<DownloadOutlined />}
						size="middle"
						style={{ height: 32, lineHeight: '32px' }}
						href={`${process.env.REACT_APP_API_URL || '/'}api/admin/incomplete-profiles-download?token=${auth.token}`}
						target="_blank"
						download
					/>
				</Col>
				<Col md={7} xs={16}>
					<Search allowClear placeholder="Filter" value={filter} onChange={handleSetFilter} onSearch={setFilter} />
				</Col>
			</Row>
			<Table
				rowKey={'profile_id'}
				columns={columns}
				dataSource={profiles}
				pagination={{ pageSize: DEFAULT_PAGE_SIZE, current: page, total }}
				loading={loading}
				onChange={onChange}
				scroll={{ x: true }}
			/>
		</Space>
	)
}

export default IncompleteProfiles

type Order = 'ascend' | 'descend' | undefined
type OnChange = (
	pagination: TablePaginationConfig,
	filters: Record<string, FilterValue | null>,
	sorter: SorterResult<any> | SorterResult<any>[]
) => void
